import {defineEnv} from '@cosctl/environment';

// App metadata environment variables
export const variables = {
  APP_VERSION: defineEnv({
    key: 'PUBLIC_APP_VERSION',
    default: '0.0.0',
    description: 'Application version number',
  }),

  APP_BRANCH: defineEnv({
    key: 'PUBLIC_APP_BRANCH',
    default: 'dev',
    description: 'Git branch the application was built from',
  }),

  APP_COMMIT: defineEnv({
    key: 'PUBLIC_APP_COMMIT',
    default: 'HEAD',
    description: 'Git commit the application was built from',
  }),
};
